import React from 'react';
import { InquiryStatus, InquiryStatusArray } from '../enums';
import { SelectComponet } from '../../../../../Components';
import { Close } from '@material-ui/icons';
import { IconButton, makeStyles } from '@material-ui/core';
import { stringToCamelCase } from '../../../../../Helper';
import clsx from 'clsx';

const styles = makeStyles({
  inProgress: {
    '& .select-body-wrapper': {
      backgroundColor: '#eff8ff',
      '& .MuiInput-input': {
        color: '#7f75d3',
      },
    },
  },
  closed: {
    '& .select-body-wrapper': {
      backgroundColor: '#D1FADF',
      '& .MuiInput-input': {
        color: '#027A48',
      },
    },
  },
  pending: {
    '& .select-body-wrapper': {
      backgroundColor: '#FEF9C3',
      '& .MuiInput-input': {
        color: '#B42318',
      },
    },
  },
});

const InquiryStatusSelect = ({
  loading,
  disabled,
  status,
  onChange,
  className,
  label,
  withClearButton,
}) => {
  const [value, setValue] = React.useState(status);
  const classes = styles();
  const onChangeHandler = (newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  return (
    <SelectComponet
      key={value}
      data={InquiryStatusArray}
      valueInput={'id'}
      textInput={'name'}
      isLoading={loading}
      isDisabled={disabled}
      onSelectChanged={onChangeHandler}
      wrapperClasses={clsx(
        className,
        classes[stringToCamelCase(InquiryStatus[value])]
      )}
      value={value}
      labelValue={label}
      endAdornment={
        withClearButton &&
        value && (
          <IconButton onClick={() => onChangeHandler()} className='m-0 p-0'>
            <Close />
          </IconButton>
        )
      }
    />
  );
};
export default InquiryStatusSelect;
